import withLazy from 'hoc/withLazy';

export default withLazy(
    () =>
        import(
            /* webpackChunkName: "components-MultiCarousel" */ './MultiCarousel'
        )
);
